<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>

  <main class="container py-4">
    <div class="mb-4">
      <h4 class="mb-1 fw-bold">Settings</h4>
      <div class="text-muted small">
        Administrative tools, sync actions, and operational controls
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <h6 class="fw-bold mb-3">Quick Actions</h6>

        <div class="border rounded-3 p-3 bg-white">
          <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
            <div>
              <div class="fw-semibold">Sync Nigerian Banks</div>
              <div class="text-muted small mt-1">
                Pull the latest Nigerian institutions from Flutterwave into the global lookup table.
              </div>
            </div>

            <button
              class="btn btn-primary"
              type="button"
              (click)="syncNigerianBanks()"
              [disabled]="syncingNigerianBanks">
              <span *ngIf="syncingNigerianBanks" class="spinner-border spinner-border-sm me-2"></span>
              {{ syncingNigerianBanks ? 'Syncing...' : 'Sync Nigerian Banks' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <h6 class="fw-bold mb-3">Sync Institutions by Country and Provider</h6>

        <form [formGroup]="form" novalidate>
          <div class="row g-3 align-items-end">
            <div class="col-md-4">
              <label class="form-label">Country Code</label>
              <input
                type="text"
                class="form-control text-uppercase"
                formControlName="countryCode"
                placeholder="NG" />
              <div class="text-danger small mt-1" *ngIf="isInvalid('countryCode')">
                Enter a valid country code.
              </div>
            </div>

            <div class="col-md-5">
              <label class="form-label">Provider</label>
              <select class="form-select" formControlName="providerCode">
                <option value="">Select provider</option>
                <option *ngFor="let provider of providers" [value]="provider.code">
                  {{ provider.name }} ({{ provider.code }})
                </option>
              </select>
              <div class="text-danger small mt-1" *ngIf="isInvalid('providerCode')">
                Select a provider.
              </div>
              <div class="text-muted small mt-1" *ngIf="loadingProviders">
                Loading providers...
              </div>
            </div>

            <div class="col-md-3">
              <button
                class="btn btn-outline-primary w-100"
                type="button"
                (click)="syncInstitutions()"
                [disabled]="syncingGenericInstitutions || loadingProviders">
                <span *ngIf="syncingGenericInstitutions" class="spinner-border spinner-border-sm me-2"></span>
                {{ syncingGenericInstitutions ? 'Syncing...' : 'Sync Institutions' }}
              </button>
            </div>
          </div>
        </form>

        <div class="alert alert-secondary mt-3 mb-0">
          <div class="fw-semibold mb-1">Notes</div>
          <div class="small">
            Use this for future countries and providers as your payout infrastructure expands.
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>